import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="testimoni" className="py-24 bg-[#FFFDF9]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">
            Testimoni
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1C1917] tracking-tight">
            Kata Mereka Tentang Kami
          </h2>
          <p className="mt-4 text-[#786F66]">
            Kepercayaan pasangan yang telah mempercayakan momen istimewanya kepada
            Ascarya Dekorasi.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative bg-white rounded-2xl border border-[#E5D7C5] p-7 shadow-[0_4px_20px_rgba(28,25,23,0.05)]"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="w-8 h-8 text-[#E8D9BD]" />
              <div className="flex gap-1 mt-3">
                {Array.from({ length: t.rating || 5 }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#C5A059] text-[#C5A059]" />
                ))}
              </div>
              <p className="mt-4 text-[#4A443F] leading-relaxed italic">
                "{t.message}"
              </p>
              <div className="mt-5 pt-4 border-t border-[#E5D7C5]">
                <div className="font-serif text-lg font-semibold text-[#1C1917]">
                  {t.name}
                </div>
                <div className="text-xs tracking-wide text-[#967C52]">{t.event}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
